export default __webpack_public_path__ + "static/media/Takbir.eb18275e.mp3";